import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import moment from 'moment';

import Icon from '../../../../../components/Icon';

const RotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  padding: 18px;
  border: 1px solid var(--secondary-gray);
  box-sizing: border-box;
  border-radius: 4px;
  margin: 16px 0;
  display: flex;
  min-height: 84px;
`;

const InfoWrapper = styled.div`
  flex-direction: column;
  display: flex;
  `;

const LoaderWrapper = styled.div`
  margin-left: 8px;
`;

const UploadedInfo = styled.span`
  color: var(--light-blue);
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
`;

const UserName = styled.span`
  font-style: italic;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: var(--light-opacity-gray);
`;

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LoaderIcon = styled(Icon)`
  animation: ${RotateAnimation} 2s linear infinite;
  color: var(--light-blue);
`;


const DownloadWrapper = styled.div`
  color: var(--light-blue);
  cursor: pointer;
  margin-top: 4px;

  &:hover {
    opacity: 0.8;
  }

  & > a {
    text-decoration: none;
    margin-left: 4px;
    color: inherit;    
  }
`;

class FileContainer extends Component {
  state = { }

  render() {
    const {
      uploadedDate, userName, file, isLoading,
    } = this.props;

    return (
      <Container>
        {isLoading ? (
          <LoaderContainer>
            <LoaderIcon name="loader" />
            <LoaderWrapper>
              <UploadedInfo>Carregando novo documento...</UploadedInfo>
            </LoaderWrapper>
          </LoaderContainer>
        ) : (
          <React.Fragment>
            <InfoWrapper>
              <UploadedInfo>{`Última atualização ${moment(uploadedDate).format('DD/MM/YYYY • HH:mm:ss')}`}</UploadedInfo>
              <UserName>{`Upload por ${userName}`}</UserName>
              <DownloadWrapper>
                <Icon name="in" />
                <a href={`data:application/pdf;base64,${file}`} fileName="pae.pdf" download>Baixar</a>
              </DownloadWrapper>
            </InfoWrapper>
          </React.Fragment>
        )}
      </Container>
    );
  }
}

export default FileContainer;
